import styled from 'styled-components';

import * as text from '@/components/general/TextStyles';

interface IFeatureOpen {
  open?: boolean;
  $adaptiveHeight?: number;
  $mainPage?: boolean;
  $isEmpty?: boolean;
}

export const TitleBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListItemBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CheckIconBox = styled.div`
  align-self: flex-start;
  margin-right: 13px;
`;

export const CheckMark = styled.img``;

export const FeatureTitle = styled.span`
  ${text.FS14}
  line-height: 20.3px;
  padding-right: 10px;
  font-weight: ${(props) => props.theme.weights.semiBold};
`;

export const ArrowBox = styled.div<IFeatureOpen>`
  transform: ${(props: IFeatureOpen) => `rotate(${props.open ? 180 : 0}deg)`};
  transition: ${(props) => props.theme.transition.primary};
`;

export const FeatureOpen = styled.div<IFeatureOpen>`
  will-change: opacity, margin-top, height;
  height: ${(props: IFeatureOpen) =>
    props.$mainPage
      ? props.open
        ? `${props.$adaptiveHeight + 17}px`
        : '0'
      : props.open
      ? `${props.$adaptiveHeight}px`
      : '0'};
  margin-left: 40px;
  ${(props: IFeatureOpen) =>
    !props.$mainPage && props.open && 'margin-top: 2px;'}
  padding-bottom: ${(props: IFeatureOpen) =>
    props.$mainPage ? (props.open ? '17px' : '0px') : '0px'};
  opacity: ${(props: IFeatureOpen) => (props.open ? '1' : '0')};
  overflow: hidden;
  transition: ${(props) => props.theme.transition.primary};
  width: calc(100% - 40px);
`;

export const FeatureText = styled.p`
  width: calc(100% - 30px);
  font-size: 14px;
  line-height: 170%;
  font-weight: ${(props) => props.theme.weights.regular};
`;

export const FeaturesListItem = styled.li<IFeatureOpen>`
  width: 100%;
  background: ${(props) => props.theme.colors.offGreen};
  cursor: ${(props: IFeatureOpen) => (props.$isEmpty ? 'default' : 'pointer')};
  position: relative;
  border-radius: 16px;
  padding: 13px 10px 13px 13px;
  user-select: none;
  list-style: none;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: 100%;
  }

  ${(props) =>
    props.$mainPage &&
    `
    padding: 0;
    margin-bottom: 0;
    background-color: transparent;
    border-bottom: 1px solid #dfdfea;
    border-radius: 0px !important;

    &:not(:last-child) {
      margin-bottom: 0;
    }

    ${FeatureTitle} {
      ${text.FS24}
      font-weight: ${props.theme.weights.regular};
      padding: 40px 15px 40px 0;

      @media (max-width: ${props.theme.breakpoints.md}px) {
        font-size: 20px;
        line-height: 165%;
        padding: 25px 12px 25px 0;
      }
      @media (max-width: ${props.theme.breakpoints.sm}px) {
        font-size: 17px;
        padding: 15px 10px 15px 0;
      }
    }
    ${FeatureOpen} {
      margin-left: 0px;
    }
    ${FeatureText} {
      ${text.FS17}
      width: 100%;

      @media (max-width: ${props.theme.breakpoints.md}px) {
        font-size: 15px;
      }
      @media (max-width: ${props.theme.breakpoints.sm}px) {
        font-size: 13px;
      }
    }
  `}
`;
